import Vue from 'vue'
// import App from './App.vue'
// import router from './router'
// import store from './store'
import { renderApp } from './plugins/vuetify';
import './plugins/axios'; // Configuração do axios com interceptor para i18n
import { VueMaskDirective } from 'v-mask'
import DatetimePicker from 'vuetify-datetime-picker'
import VueApexCharts from 'vue-apexcharts';

import { Icon } from 'leaflet'

delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';

Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component('apexchart', VueApexCharts);
Vue.use(DatetimePicker);
Vue.use(VueApexCharts);

Vue.directive('mask', VueMaskDirective);

Vue.config.productionTip = false

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(() => console.log('SW registrado'))
      .catch(() => console.log('Erro ao registrar SW'));
  });
}

renderApp();
